import { enumRecord } from 'aos-helpers/src/helpers/Enum'
import { sortBy, uniqBy } from 'lodash'

import { InspectionItemPayload } from '../payload/InspectionTaskFormPayload'
import { InspectionMetadataType } from '../TaskMetadata'
import { InspectionGroup } from './InspectionGroup'

export interface InspectionConfig {
    group: InspectionGroup
    items: InspectionItemPayload[]
    selectedItems: InspectionItemPayload[]
}

export type InspectionTypeGroup = Record<InspectionGroup, InspectionConfig>

export const inspectionTypeToGroups = (
    types: InspectionMetadataType[],
    selectedInspections: InspectionItemPayload[],
): InspectionTypeGroup => {
    const selectedIds = new Set(selectedInspections.map(i => i.inspectionType.id))
    const selectionForInspection = (group: InspectionGroup): InspectionConfig => {
        const allOfGroup: InspectionItemPayload[] = types
            .filter(i => i.inspectionGroup === group)
            .map(type => ({
                inspectionType: {
                    id: type.id,
                    name: type.name,
                    code: type.code,
                    period: type.period,
                    inspectionGroup: type.inspectionGroup,
                    taskEndTime: type.taskEndTime,
                },
            }))

        return {
            items: allOfGroup,
            group,
            selectedItems: allOfGroup.filter(i => selectedIds.has(i.inspectionType.id)),
        }
    }

    return enumRecord(InspectionGroup, selectionForInspection)
}

export const diffSelection = (
    selectedInspections: InspectionItemPayload[],
    currentPayload: InspectionItemPayload[],
    inspectionGroup: InspectionGroup,
): InspectionItemPayload[] => {
    const selectedIds = new Set(selectedInspections.map(i => i.inspectionType.id))
    const keptPayload = currentPayload.filter(
        i =>
            i.inspectionType.inspectionGroup !== inspectionGroup ||
            selectedIds.has(i.inspectionType.id),
    )
    return uniqBy(keptPayload.concat(selectedInspections), i => i.inspectionType.id)
}

export const sortInspectionTypes = (
    types: InspectionMetadataType[],
    groupOrder: string[],
): InspectionMetadataType[] =>
    sortBy(
        types.filter(t => groupOrder.includes(t.inspectionGroup)),
        t => groupOrder.indexOf(t.inspectionGroup),
    )
